<template>
  <a @click="routeToPage($event)" class="vertical-menu-item" :class="{'active': isActive}">
    <div class="icon">
      <LucideIcon :icon="icon" style="font-size:18px;"/>
    </div>
    <div class="content">{{ label }}</div>
  </a>
</template>
<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'VerticalMenuItemElement',
  props: {
    icon: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    routeToPage(e: Event): void {
      this.$router.push({name: this.name});
      e.preventDefault();
    },
  },
});
</script>
<style lang="scss" scoped>
.vertical-menu-item {
  display: flex;
  align-items: center;
  height: 40px;
  padding: var(--space-8) var(--space-16);
  margin-bottom: var(--space-4);
  border-radius: $br-sm;
  cursor: pointer;
  background-color: var(--button-vertical-menu-sitemap-bg);
  border: 1px solid var(--button-vertical-menu-sitemap-border);
  color: var(--text-dark);

  &:hover {
    background-color: var(--button-vertical-menu-sitemap-bg-hover);
    border: 1px solid var(--button-vertical-menu-sitemap-border-hover);

  }

  &.active {
    background-color: var(--button-vertical-menu-bg-active);
    border: 1px solid var(--button-vertical-menu-border-active);
    box-shadow: var(--button-vertical-menu-shadow);
  }

  & > .icon {
    display: flex;
    align-items: center;
    width: 40px;
    justify-content: center;
    margin-right: 10px;
  }

  & > .content {
    width: 100%;
    font-size: var(--fs-14);
  }

}

</style>
